import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons"

export const FolderOpen = (props) => {
  return <FontAwesomeIcon faIcon={faFolderOpen} {...props} />
}
